import { Input } from 'antd';
import './searchBar.scss';

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchBar = ({ value, onChange }: SearchBarProps) => {
  return (
    <div className="search-bar-container">
      <i className="bx bx-search"></i>
      <Input
        size="large"
        placeholder="Search"
        className="search-input"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBar;
